import { Navigate, createBrowserRouter } from "react-router-dom";
import DefaultLayout from "./components/DefaultLayout";
import GuestLayout from "./components/GuestLayout";

import Dashboard from "./views/dashboard/Dashboard";

import Login from "./views/auth/Login";
import GestAdmins from "./views/gestion_admins/GestAdmins";
import GestClients from "./views/gestion_clients/GestClients";
import GestSubscription from "./views/gestion_subscription/GestSubscription";
import GestCategory from "./views/gestion_categories/GestCategory";
import RequireAuth from "./hooks/RequireAuth";
import Profile from "./views/profile/Profile";
import EditProfile from "./views/profile/EditProfile";
import Security from "./views/profile/Security";
import ResetPassword from "./views/auth/ResetPassword";
import ResetPwdPage from "./views/auth/ResetPwdPage";
import AddAdmin from "./views/gestion_admins/AddAdmin";
import EditAdmin from "./views/gestion_admins/EditAdmin";
import AddMovie from "./views/gestion_content/gestion_movies/AddMovie";
import GestMovies from "./views/gestion_content/gestion_movies/GestMovies";
import MovieDetails from "./views/gestion_content/gestion_movies/MovieDetails";
import GestSeries from "./views/gestion_content/gestion_series/GestSeries";
import SerieDetails from "./views/gestion_content/gestion_series/SerieDetails";
import AddSerie from "./views/gestion_content/gestion_series/AddSerie";
import AddEpisode from "./views/gestion_content/gestion_series/gestion_episodes/AddEpisode";
import EditMovie from "./views/gestion_content/gestion_movies/EditMovie";
import EditEpisode from "./views/gestion_content/gestion_series/gestion_episodes/EditEpisode";
import EditSerie from "./views/gestion_content/gestion_series/EditSerie";
import GestPays from "./views/gestion_pays/GestPays";
import GestPromoCode from "./views/gestion_promoCodes/GestPromoCode";
import AddClient from "./views/gestion_clients/AddClient";
import NotFound from "./views/NotFound";
import Unauthorized from "./views/Unauthorized";
import SubscriptionStats from "./views/dashboard/SubscriptionStats";
import Updates from "./views/gestion_updates/Updates";
import ContentsStats from "./views/dashboard/ContentsStats";
import WelcomePageEditor from "./views/welcome_page/WelcomePageEditor";
import MovieHistory from "./views/gestion_content/gestion_movies/MovieHistory";
import SerieHistory from "./views/gestion_content/gestion_series/SerieHistory";
import EpisodeHistory from "./views/gestion_content/gestion_series/gestion_episodes/EpisodeHistory";
import CategoryHistory from "./views/gestion_categories/CategoryHistory";
import GestHighlightedContent from "./views/gestion_content/highlighted_content/GestHighlightedContent";
import ContentStats from "./views/dashboard/ContentStats";
import GestNewContent from "./views/gestion_content/new_content/GestNewContent";
import PromoCodeUsage from "./views/dashboard/PromoCodeUsage";
import GestGames from "./views/gestion_games/GestGames";
import AddGame from "./views/gestion_games/AddGame";
import EditGame from "./views/gestion_games/EditGame";
import GameDetails from "./views/gestion_games/GameDetails";




const router = createBrowserRouter([
  {
    path: '/',
    element: <RequireAuth element={<DefaultLayout/>}/>,
    children: [
      {
        path: '/',
        element: <RequireAuth element={<Dashboard/>}/>
      },
      {
        path: '/stats',
        element: <RequireAuth element={<SubscriptionStats/>} allowedRoles={['SUPERADMIN']}/>
      },
      {
        path: '/contents-stats',
        element: <RequireAuth element={<ContentsStats/>} />
      },
      {
        path: '/content-stats',
        element: <RequireAuth element={<ContentStats/>}/>
      },
      {
        path: '/admins',
        element:<RequireAuth element={<GestAdmins/>} allowedRoles={['SUPERADMIN']}/>  
      },
      
      {
        path: '/ajouter-admin',
        element:<RequireAuth element={<AddAdmin/>} allowedRoles={['SUPERADMIN']}/>  
      },
      {
        path: '/modifier-admin',
        element:<RequireAuth element={<EditAdmin/>} allowedRoles={['SUPERADMIN']}/>  
      },
      {
        path: '/users',
        element: <RequireAuth element={<GestClients/>}/>
      },
      {
        path: '/ajouter-client',
        element: <RequireAuth element={<AddClient/>}/>
      },
      {
        path: '/subscription',
        element: <RequireAuth element={<GestSubscription/>}  allowedRoles={['SUPERADMIN']}/>
      },
      {
        path: '/categories',
        element: <RequireAuth element={<GestCategory/>}/>
      },
      {
        path: '/profil',
        element:<RequireAuth element={<Profile/>}/>  
      },
      {
        path: '/modifier-profil',
        element:<RequireAuth element={<EditProfile/>}/>  
      },
      {
        path: '/securite-de-compte',
        element:<RequireAuth element={<Security/>}/>  
      },
      {
        path: '/ajouter-film',
        element:<RequireAuth element={<AddMovie/>}/>  
      },
      {
        path: '/modifier-film',
        element:<RequireAuth element={<EditMovie/>}/>  
      },
      {
        path: '/films',
        element:<RequireAuth element={<GestMovies/>}/>  
      },
      {
        path: '/detail-film',
        element:<RequireAuth element={<MovieDetails/>}/>  
      },
      {
        path: '/series',
        element:<RequireAuth element={<GestSeries/>}/>  
      },
      {
        path: '/ajouter-serie',
        element:<RequireAuth element={<AddSerie/>}/>  
      },
      {
        path: '/modifier-serie',
        element:<RequireAuth element={<EditSerie/>}/>  
      },
      {
        path: '/detail-serie',
        element:<RequireAuth element={<SerieDetails/>}/>  
      },
      {
        path: '/ajouter-episode',
        element:<RequireAuth element={<AddEpisode/>}/>  
      },
      {
        path: '/modifier-episode',
        element:<RequireAuth element={<EditEpisode/>}/>  
      },
      {
        path: '/pays',
        element:<RequireAuth element={<GestPays/>}/>  
      },
      {
        path: '/codes-promo',
        element:<RequireAuth element={<GestPromoCode/>} allowedRoles={['SUPERADMIN']}/>  
      },
      {
        path: '/updates',
        element:<RequireAuth element={<Updates/>} allowedRoles={['SUPERADMIN']}/>  
      },
      {
        path: '/editor',
        element:<RequireAuth element={<WelcomePageEditor/>} />  
      },
      {
        path: '/historique_film',
        element: <RequireAuth element={<MovieHistory />} />
      },
      {
        path: '/historique_serie',
        element: <RequireAuth element={<SerieHistory />} />
      },
      {
        path: '/historique_episode',
        element: <RequireAuth element={<EpisodeHistory />} />
      },
      {
        path: '/historique_categorie',
        element: <RequireAuth element={<CategoryHistory />} />
      },
      {
        path: '/highlight',
        element: <RequireAuth element={<GestHighlightedContent />} />
      },
      {
        path: '/new_contents',
        element: <RequireAuth element={<GestNewContent />} />
      },
      {
        path: '/promo-usage',
        element: <RequireAuth element={<PromoCodeUsage/>} />
      },
      {
        path: '/jeux',
        element: <RequireAuth element={<GestGames/>} />
      },
      {
        path: '/ajouter-jeu',
        element: <RequireAuth element={<AddGame/>} />
      },
      {
        path: '/modifier-jeu',
        element: <RequireAuth element={<EditGame/>} />
      },
      {
        path: '/detail-jeu',
        element: <RequireAuth element={<GameDetails/>} />
      },
      
    ]
  },
  {
    path: '/',
    element: <GuestLayout />,
    children: [
      {
        path: '/login',
        element: <Login />
      },
      {
        path: '/reset_password',
        element: <ResetPassword />
      },
      {
        path: '/reinitialisation_de_motdepasse/:userId/:token/:expires',
        element: <ResetPwdPage />
      },
      
    ]
  },
  {
    path: "/unauthorized",
    element: <Unauthorized />
  },
  {
    path: "*",
    element: <NotFound />
  }

  
])

export default router;
